import { ReactComponent as SearchSvg } from '../../assets/icons/search.svg';

export const SearchIcon: SvgIcon = (props) => {
    return <SearchSvg {...props} />;
};
